import { RecordActionGroup } from "../../app/newLayout/page/components/PurchaseOrderDetails/RecordActionGroup";

const EditLayoutIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    <rect x="1.25" y="1.25" width="8.1" height="8.1" rx="1.6" fill="currentColor" />
    <rect x="10.85" y="1.25" width="8.1" height="8.1" rx="1.6" fill="currentColor" />
    <rect x="1.25" y="10.85" width="8.1" height="8.1" rx="1.6" fill="currentColor" />
    <rect x="10.85" y="10.85" width="8.1" height="8.1" rx="1.6" fill="currentColor" />
    <g transform="translate(17.7 17.7)">
      <circle className="editColumnsPlate" r="6.5" />
      <g fill="currentColor">
        <rect x="-1.05" y="-5.7" width="2.1" height="2.15" rx="0.45" />
        <rect x="-1.05" y="-5.7" width="2.1" height="2.15" rx="0.45" transform="rotate(45)" />
        <rect x="-1.05" y="-5.7" width="2.1" height="2.15" rx="0.45" transform="rotate(90)" />
        <rect x="-1.05" y="-5.7" width="2.1" height="2.15" rx="0.45" transform="rotate(135)" />
        <rect x="-1.05" y="-5.7" width="2.1" height="2.15" rx="0.45" transform="rotate(180)" />
        <rect x="-1.05" y="-5.7" width="2.1" height="2.15" rx="0.45" transform="rotate(225)" />
        <rect x="-1.05" y="-5.7" width="2.1" height="2.15" rx="0.45" transform="rotate(270)" />
        <rect x="-1.05" y="-5.7" width="2.1" height="2.15" rx="0.45" transform="rotate(315)" />
        <circle r="3.55" />
        <circle className="editColumnsPlate" r="1.45" />
      </g>
    </g>
  </svg>
);

const RefreshIcon = () => (
  <svg width="16" height="16" viewBox="0 0 18 18" aria-hidden="true">
    <path
      d="M8.9989 18C6.4864 18 4.35828 17.1281 2.61453 15.3844C0.870776 13.6406 -0.00109863 11.5125 -0.00109863 9C-0.00109863 6.4875 0.870776 4.35938 2.61453 2.61563C4.35828 0.871875 6.4864 0 8.9989 0C10.2927 0 11.5302 0.267188 12.7114 0.801563C13.8927 1.33594 14.9052 2.1 15.7489 3.09375V0H17.9989V7.875H10.1239V5.625H14.8489C14.2489 4.575 13.4286 3.75 12.388 3.15C11.3473 2.55 10.2177 2.25 8.9989 2.25C7.1239 2.25 5.53015 2.90625 4.21765 4.21875C2.90515 5.53125 2.2489 7.125 2.2489 9C2.2489 10.875 2.90515 12.4688 4.21765 13.7812C5.53015 15.0938 7.1239 15.75 8.9989 15.75C10.4427 15.75 11.7458 15.3375 12.9083 14.5125C14.0708 13.6875 14.8864 12.6 15.3552 11.25H17.7177C17.1927 13.2375 16.1239 14.8594 14.5114 16.1156C12.8989 17.3719 11.0614 18 8.9989 18Z"
      fill="currentColor"
    />
  </svg>
);

/** Icon Edit / Refresh actions for the operations dashboard header (order detail button style). */
export function OperationsHeaderActions({ isFetching, onEditLayout, onRefresh }) {
  return (
    <RecordActionGroup className="btnGroup summaryActions operations-header-actions">
      <button
        type="button"
        className="iconWrapper editColumnsIcon"
        onClick={onEditLayout}
        title="Edit dashboard"
        aria-label="Edit"
      >
        <EditLayoutIcon />
      </button>
      <button
        type="button"
        className="iconWrapper"
        onClick={onRefresh}
        disabled={isFetching}
        title={isFetching ? "Refreshing…" : "Refresh"}
        aria-label="Refresh"
      >
        <RefreshIcon />
      </button>
    </RecordActionGroup>
  );
}
